import React from 'react';
import PropTypes from 'prop-types';
import Link from '../Global/Link';
import SocialLinks from '../Global/SocialLinks';
import HutchLogo from '../../../static/images/hutch_logo_white.png';
import ImageHandler from '../../utils/ImageHandler';

const Footer = (props) => {
  const { mode, settings } = props;

  return (
    <>
      {settings.accolades && (
        <div className="pt-5 pb-4 brand-background-black">
          <div className="container text-center">
            <ul className="list-inline">
              {settings.accolades.map((item, idx) => {
                return (
                  <li className="list-inline-item ml-4 mr-4" key={idx + 1}>
                    <img
                      src={`${ImageHandler(
                        item.image.filename,
                        'fit-in/200x200/filters:quality(100)',
                      )}`}
                      alt={item.title}
                      className="brand-accolade-image"
                    />
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      )}

      <footer className="w-100 pt-5 pb-5 brand-background-blacker font-small">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-12 col-md-5 text-center text-md-left d-md-flex align-items-center">
              <div className="mr-0 mr-md-3 mb-3">
                <img src={HutchLogo} alt="Hutch" className="brand-logo-image" />
              </div>
              <div>
                <p>
                  <span className="small">&copy;</span> 2021 Hutch Games Ltd.
                </p>
                <p className="small brand-text-grey">{settings.legal_copy}</p>
              </div>
            </div>

            <div className="col-12 col-md-6 text-center text-md-right">
              <SocialLinks
                itemClassName="mx-3 mx-md-0 ml-md-3 "
                links={[
                  ['facebook', settings.facebook_link],
                  ['twitter', settings.twitter_link],
                  ['twitch', settings.twitch_link],
                  ['instagram', settings.instagram_link],
                  ['youtube', settings.youtube_link],
                  ['linkedin', settings.linkedin_link],
                ]}
              />

              <ul className="small">
                {settings.footer_links.map((item, idx) => {
                  return (
                    <li key={item.slug}>
                      <Link to={`/${item.slug}/`}>{item.name}</Link>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;

Footer.propTypes = {
  settings: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  mode: PropTypes.string,
};

Footer.defaultProps = {
  settings: null,
  mode: 'normal',
};
